import { Box, Container, useMediaQuery, useTheme } from '@mui/material';
import dynamic from 'next/dynamic';
import { memo } from 'react';
import ButtonCarousel from './ButtonCarousel/ButtonCarousel';
import Description from './Description/Description';
import DescriptionList from './DescriptionList/DescriptionList';
import Heading from './Heading/Heading';
import { disclaimerWrapperStyles, groupedContentStyles, headerSectionStyles, mediaSliderStylesSection, wrapper } from './ProductFeature.styles';
import { IProductFeatureProps } from './ProductFeature.type';
import Disclaimer from '@shared-components/components/Disclaimer';
import { textToJumpLink } from '@utils/textToJumpLink';
const MediaSlider = dynamic(() => import('./MediaSlider/MediaSlider'));
const ProductFeatureContent = memo(function ProductFeatureContent({
  headline,
  descriptionRichText,
  descriptionButton,
  descriptionButtonsCollection,
  descriptionListCollection,
  buttonsCollection,
  media,
  disclaimer,
  enableSliderControlsBackgroundGradient = true
}: IProductFeatureProps) {
  const disclaimerData = disclaimer?.disclaimer;
  return <>
			<Box sx={headerSectionStyles}>
				<Heading {...headline} />
			</Box>
			<Box sx={mediaSliderStylesSection}>
				<MediaSlider {...media} enableSliderControlsBackgroundGradient={enableSliderControlsBackgroundGradient ?? true} />
			</Box>
			<Box sx={groupedContentStyles}>
				<Description descriptionRichText={descriptionRichText} descriptionButton={descriptionButton} descriptionButtonsCollection={descriptionButtonsCollection} />
				<DescriptionList descriptionListCollection={descriptionListCollection} />
				<ButtonCarousel buttonsCollection={buttonsCollection} />
				{disclaimerData ? <Disclaimer disclaimer={disclaimerData} dataTestId="product_feature_disclaimer" wrapperSx={disclaimerWrapperStyles} disableGutters /> : null}
			</Box>
		</>;
});
export default function ProductFeature(props: IProductFeatureProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return <Container {...props?.anchorId && {
    id: textToJumpLink(props.anchorId)
  }} data-testid={`section_product_feature_${isMobile ? 'mobile' : 'desktop'}`} sx={wrapper} maxWidth={false} data-sentry-element="Container" data-sentry-component="ProductFeature" data-sentry-source-file="ProductFeature.tsx">
			<ProductFeatureContent {...props} data-sentry-element="ProductFeatureContent" data-sentry-source-file="ProductFeature.tsx" />
		</Container>;
}